// Port of api/fuel/app/classes/filter/package/games/play/package/games/players/user.php
import F from 'offline/filter/constants'
export default {
	require: function(config, filter) { return config.ownerType === F.OWNER_USER && filter.play && filter.play.group },
	run: function(pkg, local, global) {
		pkg.players = local.players || []
		pkg.players.push({
			id: global.userID,
			name: global.owner && global.owner.get_fullname && global.owner.get_fullname()
				? global.owner.get_fullname()
				: (global.owner && global.owner.get_name ? global.owner.get_name() : ''),
			plays: local.record.plays || 0,
			results: local.record.results || 0,
			wins: local.record.wins || 0
		})
		pkg.record = local.record || {}
		return pkg
	}
}
